<template>
    <div class="banner">
        <div class="item" @click="picbtn(url[currentIndex])">
            <img :src="swiperpic[currentIndex]" />
        </div>
        <div class="page" v-if="this.swiperpic.length > 1">
            <ul>
                <li
                    v-for="(item,index) in swiperpic"
                    :Key="index"
                    @click="gotoPage(index)"
                    :class="{'current':currentIndex == index}"
                    ></li>
            </ul>
            <div class="control-position">
                <a class="el-icon-arrow-left" @click="gotoPage(prevIndex)"></a>
                <a class="el-icon-arrow-right" @click="gotoPage(nextIndex)"></a>
            </div>
            
        </div>

        <div></div>
    </div>
</template>
<script>
export default {
    props:{
		swiperpic:{
			type:Array
		},
        url:{
            type:Array
        }
	},
    data() {
        return {
            // swiperpic: [
            //     require("../assets/image/lunbo01.jpg"),
            //     require("../assets/image/lunbo02.jpg"),
            //     require("../assets/image/lunbo03.jpg"),
            //     require("../assets/image/lunbo04.jpg"),
            // ],
            currentIndex: 0, //默认显示图片
            timer: null //定时器
        };
    },
    computed: {
        //上一张
        prevIndex() {
            if (this.currentIndex == 0) {
                return this.swiperpic.length - 1;
            } else {
                return this.currentIndex - 1;
            }
        },
        //下一张
        nextIndex() {
            if (this.currentIndex == this.swiperpic.length - 1) {
                return 0;
            } else {
                return this.currentIndex + 1;
            }
        }
    },
    methods: {
        //定时器
        runInv() {
            this.timer = setInterval(() => {
                this.gotoPage(this.nextIndex);
            }, 2000);
        },
        gotoPage(index) {
            this.currentIndex = index;
        },
        picbtn(url){
            window.open(url)
        }
    },
    mounted() {
        this.runInv();
    }
};
</script>

<style lang="less" scoped>

    ul li{
        float: left;
        width: 50px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        color: rgba(255, 255, 255);
        font-size: 50px;
        
    }
    .banner{
        margin: 20px auto;
        position: relative;
        .page{
            position: absolute;
            right: 0;
            bottom: 0;
            width: 100%;
            ul{
                width: 220px;
                margin: 0 auto;
            }
        }
    }
    .current{
        color: #d61d23;
    }
    .item{
        width: 100%;
        height: 450px;
    }
    .banner img{
        width: 100%;
        display: block;
    }
    .control-position{
        a{
            position: absolute;
            z-index: 20;
            width: 70px;
            height: 70px;
            cursor: pointer;
            font-size: 60px;
            text-align: center;
            line-height: 70px;
            color: #ccc;
            background:rgba(80,80, 80, 0.3)
        }
        .el-icon-arrow-left{
            top: -230px;
            left: 0px;
        }
        .el-icon-arrow-right{
            top:-230px;
            right: 0px;

        }
    }
    img{
        width: 100%;
        height: 100%;
    }
</style>